import { motion } from "framer-motion";
import { FaReact, FaGitAlt } from "react-icons/fa";
import {
  SiJavascript,
  SiTypescript,
  SiFirebase,
  SiGraphql,
  SiRedux,
  SiPostman,
  SiJenkins,
  SiMongodb,
  SiJest,
} from "react-icons/si";

function Skills() {

  const skillCategories = [
    {
      title: "Core Development",
      skills: [
        { icon: <FaReact />, name: "React Native" },
        { icon: <FaReact />, name: "React.js" },
        { icon: <SiJavascript />, name: "JavaScript" },
        { icon: <SiTypescript />, name: "TypeScript" },
        { icon: <SiRedux />, name: "Redux" },
      ],
    },
    {
      title: "Mobile Development",
      skills: [
        { icon: <FaReact />, name: "React Navigation" },
        { icon: <FaReact />, name: "AsyncStorage" },
        { icon: <SiFirebase />, name: "Firebase" },
      ],
    },
    {
      title: "API & Networking",
      skills: [
        { icon: <SiGraphql />, name: "GraphQL" },
        { icon: <SiPostman />, name: "REST API" },
        { icon: <SiPostman />, name: "Axios" },
      ],
    },
    {
      title: "DevOps / SRE",
      skills: [
        { icon: <SiJenkins />, name: "Jenkins" },
        { icon: <SiJenkins />, name: "Dynatrace" },
        { icon: <SiJenkins />, name: "Splunk" },
      ],
    },
    {
      title: "Database",
      skills: [
        { icon: <SiMongodb />, name: "MongoDB" },
        { icon: <SiMongodb />, name: "SQLite" },
      ],
    },
    {
      title: "Tools",
      skills: [
        { icon: <FaGitAlt />, name: "Git" },
        { icon: <SiPostman />, name: "Postman" },
        { icon: <FaReact />, name: "Android Studio" },
        { icon: <FaReact />, name: "Xcode" },
      ],
    },
    {
      title: "Testing",
      skills: [{ icon: <SiJest />, name: "Jest" }],
    },
  ];

  return (
    <section className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#0f1d3a] to-[#0a1f44] text-white pt-40 pb-20">
      <div className="max-w-6xl mx-auto px-6">

        <h1 className="text-4xl font-bold mb-16 text-center">
          Tech Stack
        </h1>

        <div className="space-y-16">

          {skillCategories.map((category, index) => (
            <div key={index}>

              <h2 className="text-2xl font-semibold mb-8 text-blue-300">
                {category.title}
              </h2>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">

                {category.skills.map((skill, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ scale: 1.08 }}
                    className="bg-[#1b2433]/90 backdrop-blur-md p-8 rounded-xl flex flex-col items-center justify-center shadow-[0_0_30px_rgba(59,130,246,0.15)] hover:shadow-[0_0_50px_rgba(59,130,246,0.35)] transition"
                  >
                    <div className="text-5xl text-blue-400">
                      {skill.icon}
                    </div>

                    <p className="mt-4 text-gray-300 font-medium">
                      {skill.name}
                    </p>
                  </motion.div>
                ))}

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default Skills;